import styled, { css } from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/lexusTheme";
import type { InputgroupVariantsType } from "./Inputgroup";

// STYLES
const defaultStyle = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: var(--spacing-1);
    padding: var(--spacing-2);
    border: 1px solid var(--color-platinum-medium);

    input {
        width: 100%;
        margin: 0;
        padding: 0;
        font-family: var(--font-book);
        font-size: 1.8rem;
        line-height: 2.4rem;
        text-align: start;
        color: var(--color-midnight);
        background-color: transparent;
        border: 0;
        outline: 0;
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        padding: var(--spacing-2) var(--spacing-3);
    }
`;

const appendPrepend = css`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
`;

// COMPONENTS
export const Append = styled.div`
    ${appendPrepend};
`;

export const Prepend = styled.div`
    ${appendPrepend};
`;

export const InputgroupVariants = {
    default: defaultStyle,
};

const InputgroupVariant = styled.div<{ variant: InputgroupVariantsType }>`
    ${({ variant }) =>
        variant &&
        css`
            ${InputgroupVariants[variant]};
        `};
`;

export default InputgroupVariant;
